// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem 0.5rem;
  border-bottom: 1px solid #e5e5e5;
}
.dialog-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.close-btn {
  color: #666;
  padding: 0;
  min-width: auto;
}

.dialog-body {
  padding: 1rem 1.25rem;
  max-height: 70vh;
  overflow-y: auto;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 0.75rem 1.25rem 1.25rem;
  border-top: 1px solid #e5e5e5;
}

.summary-card {
  background: #f8f9fa;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 0.75rem 1rem;
}

.summary-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.35rem 0;
  border-bottom: 1px solid #ececec;
}
.summary-row:last-child {
  border-bottom: none;
}
.summary-row strong {
  text-align: right;
  max-width: 55%;
}

.risk-summary {
  border-color: #c9daf8;
  background: #f0f6ff;
}

.risk-summary .summary-title {
  color: #1a4d8f;
}`, "",{"version":3,"sources":["webpack://./src/app/features/insight-egrc/risk-management/risk-register/shared/dialogs/risk-register-asset-info-dialog/risk-register-asset-info-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,gCAAA;AACF;AACE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAGA;EACE,WAAA;EACA,UAAA;EACA,eAAA;AAAF;;AAGA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,gCAAA;EACA,6BAAA;AAAF;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,cAAA;AADJ;;AAKA;EACE,qBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":[".dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem 0.5rem;\n  border-bottom: 1px solid #e5e5e5;\n\n  h2 {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n}\n\n.close-btn {\n  color: #666;\n  padding: 0;\n  min-width: auto;\n}\n\n.dialog-body {\n  padding: 1rem 1.25rem;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.dialog-footer {\n  display: flex;\n  justify-content: center;\n  padding: 0.75rem 1.25rem 1.25rem;\n  border-top: 1px solid #e5e5e5;\n}\n\n.summary-card {\n  background: #f8f9fa;\n  border: 1px solid #e5e5e5;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n}\n\n.summary-title {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.35rem 0;\n  border-bottom: 1px solid #ececec;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  strong {\n    text-align: right;\n    max-width: 55%;\n  }\n}\n\n.risk-summary {\n  border-color: #c9daf8;\n  background: #f0f6ff;\n}\n\n.risk-summary .summary-title {\n  color: #1a4d8f;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
